module.exports = __webpack_public_path__ + "img/biodata-white.b66e3aa6.svg";